<template>
    <div class="redeem-box">
        <img src="@/assets/images/close-detail-toast.png" @click="close">
        <p class="title">兑换码</p>
        <div v-if="!redeem.exchange_address">
            <p class="value">{{ code }}</p>
            <p class="platform">兑换平台：{{ platform }}</p>
            <div class="button" :data-clipboard-text="code" @click="copy" id="redeem">复制内容</div>
        </div>
        <div v-else>
            <p class="value">{{ exchangeStr }}</p>
            <p class="platform">{{ redeem.exchange_desc }}</p>
            <div class="button" :data-clipboard-text="redeem.exchange_address" @click="copy1" id="redeem1">{{ btnText }}</div>
        </div>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
import moment from 'moment'

export default {
    props: {
        redeem: { // 新增当前点击
            type: Object,
            default: () => {
                return {}
            }
        },
        id: {
            type: Number
        },
        code: {
            type: String
        },
        platform: {
            type: String
        }
    },
    computed: {
        // 春节活动是否开启
        exchangeStr () {
            if (!this.redeem.exchange_address || moment(this.redeem.end_time).isBefore(moment())) {
                return '活动已结束'
            } else if (moment(this.redeem.start_time).isBefore(moment())) {
                return '活动已开始'
            } else {
                return '活动待开始'
            }
        },
        btnText () {
            let str = '复制内容'
            if (this.exchangeStr !== '活动已开始') {
                str = this.exchangeStr
            }
            return str
        }
    },
    data() {
        return {
            show: true
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        copy() {
            let clipBoard = new Clipboard('#redeem')
            clipBoard.on('success', () => {
                clipBoard.destroy()
                this.$toast('复制成功')
            })
            clipBoard.on('error', () => {
                clipBoard.destroy()
                this.$toast('复制失败')
            })
        },
        copy1() {
            if (this.btnText === '复制内容') {
                let clipBoard = new Clipboard('#redeem1')
                clipBoard.on('success', () => {
                    clipBoard.destroy()
                    this.$toast('复制成功，请使用浏览器打开！')
                })
                clipBoard.on('error', () => {
                    clipBoard.destroy()
                    this.$toast('复制失败')
                })
            }
        }
    }
};
</script>

<style scoped lang="scss">
.redeem-box {
    position: relative;
    width: 343px;
    color: #1B66E6;
    font-weight: 500;
    text-align: center;
    background: linear-gradient(135deg, #F3F8FF 0%, #D4DEED 100%);
    border-radius: 24px;
    img {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 25px;
        height: 25px;
    }
    .title {
        font-size: 20px;
        margin-top: 56px;
    }
    .value {
        font-size: 22px;
        word-wrap: break-word;
        padding: 29px 16px 16px;
        border-bottom: 1px solid;
        border-image: linear-gradient(270deg, rgba(21, 117, 221, 0), rgba(21, 117, 221, 1), rgba(21, 117, 221, 0)) 1 1;
    }
    .platform {
        font-size: 12px;
        font-weight: 400;
        margin-top: 16px;
    }
    .button {
        width: 215px;
        height: 44px;
        color: white;
        font-size: 16px;
        line-height: 44px;
        margin: 24px auto 34px auto;
        background: linear-gradient(139deg, #4C8EFF 0%, #115EE1 100%);
        box-shadow: 0px 10px 20px 0px rgba(75,137,241,0.35);
        border-radius: 23px;
    }
}
</style>
